import { ListProvider } from "./list-provider";
import { AccessGroup } from "../../../../business-objects/access-group/access-group.model";
import { AccessGroupStoreFacade } from "../../../../business-objects/access-group/access-group.store-facade";

export class AccessGroupListProvider extends ListProvider<AccessGroup> {

    getFacade(): AccessGroupStoreFacade {
        return this.appFacade.objects.accessGroup.store;
    }

    getPrimaryField(item: AccessGroup): string {
        return item && item.title;
    }

    getSecondaryField(item: AccessGroup): string {
        return item && item.title;
    }
}



// WEBPACK FOOTER //
// ./src/vas/controls/list-picker/form/list-providers/access-group-list-provider.ts